import yup from './yup'

export const buildingFormSchema = yup.object().shape({
  title: yup.string().label('Building Title').trimmedRequired('Building Title is required')
})
